import { always } from "../../../base/utils/ramdaEquivalents.utils";
import { makeObservableRouteDef } from "../../../base/utils/routes.utils";
import PageRegister from "./Register.page";

export const RegisterPageRoute = makeObservableRouteDef({
  identifier: 'register',
  urlFactory: always('register'),
  composeTitle: always('Register'),
  component: PageRegister,
})